import React from 'react';
import ERROR_OUTLINE from '@arrive/ui-icons/svg/ic_error_outline.svg'

import LandingPage from '../../LandingPage/LandingPage';

import ExpiredTenderStyles from './ExpiredTender.scss';

export default function ExpiredTender() {
  return (
    <LandingPage
      actionLinkTo="/find-loads"
      className={ExpiredTenderStyles.expiredTenderContainer}
      actionText="Looking for loads? Search our Load Board"
      content={
        <>
          <span>Thank you for participating in the Committed Capacity Program.</span>
          <br />
          <span>Contact your rep if you have any questions or changes.</span>
        </>
      }
      icon={ERROR_OUTLINE}
      subTitle="The opportunity to book has expired."
    />
  );
}
